import React, { Component } from "react";

// import { Route, BrowserRouter,Redirect as Router } from "react-router-dom";
import {
  Route,
  Redirect,
  Switch,
  withRouter,
  BrowserRouter as Router,
} from "react-router-dom";
// import { Redirect } from "react-router-dom";
import IdleTimer from "react-idle-timer";
// import { IdleTimeOutModal } from "./modal/IdleModal";
import { IdleTimeOutModal } from "./components/Pages/IdleTimeOutModal";
import Login from "./components/Pages/Login";
import { Spin } from "antd";
import Sidebar from "./components/sidebar/Sidebar";
import Config from "./config";
import Homepage from "./components/HomePage/HomePage";
// import EligibilityCheck from "./components/EligibilityCheck/EligibilityCheck";
import EligibilitySearchdashboard from "./components/EligibilityCheck/EligibilitySearchdashboard";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import TabNew from "./components/TabNew/TabNew";
import AddUserRegistation from "./components/UserRegistration/AddUser";
import Providertable from "./components/ClaimsSearch/ClaimsTable";
import Searchdashboard from "./components/memberSearch/Searchdashboard";
import ResetPassword from "./components/Pages/RestPassword";
import Registration from './components/Pages/Registration/Registration'
import "./App.css";
import "../src/styles/Antd.css";
import Swal from "sweetalert2";
import "antd/dist/reset.css";
import ClaimsSearchDashboard from "./components/ClaimsSearch/ClaimsSearchDashboard";
import ListUsers from "./components/ListUser/ListUser";
import SessionTimeout from "./SessionTimeout";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      sessionStorage.getItem("userEmail") !== null ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);
class App extends Component {
  constructor(props) {
    super(props);

    Config.init();
    this.state = {
      redirect: false,
      loading: false, // Loader state
    };
  }

  componentDidMount() {
    console.log(sessionStorage.getItem("origin") === window.location.href);
    if (window.location.href === sessionStorage.getItem("origin")) {
      console.log(sessionStorage.getItem("origin") === window.location.href);
      window.location.pathname = "/login";
      sessionStorage.clear();
    }
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleLogout() {
    this.setState({ showModal: false });

    sessionStorage.clear();
    window.location.pathname = "/";
  }
  // Method to toggle the loader
  setLoading = (isLoading) => {
    console.log("Loader state updated:", isLoading); // Debug log
    this.setState({ loading: isLoading });
  };

  render() {
    const { loading } = this.state;
    return (
      <>
        {/* <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={this.state.timeout}
        />
        <IdleTimeOutModal
          showModal={this.state.showModal}
          handleClose={this.handleClose}
          handleLogout={this.handleLogout}
        /> */}

        <Router>
        {this.state.loading === true && (
        <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
              <Spin size="large" tip="Loading..." />
            </div>
         )}
  
          <Switch>
            <Route path="/setpassword" exact component={ResetPassword}></Route>
            <Route
              path="/changeforgotpassword"
              exact
              component={ResetPassword}
            ></Route>
            <Route path="/" exact
            render={(props) => (
              <Login {...props} setLoading={this.setLoading} />
            )}
          />
          <Route
            path="/login"
            exact
            render={(props) => (
              <Login {...props} setLoading={this.setLoading} />
            )}
          />
              <Route path="/setpassword" exact component={ResetPassword}></Route>
            <Route
              path="/changeforgotpassword"
              exact
              component={ResetPassword}
            ></Route>
            
            <Route
            path="/Registration"
            exact
            render={(props) => (
              <Registration {...props} setLoading={this.setLoading} />
            )}
          />
          <Route path="/" render={(props) => <SessionTimeout {...props} />} />
          </Switch>
        </Router>
      </>
    );
  }
}

export default App;
